﻿import styles from './TemplateListPage.module.scss';
import { TemplateList } from './TemplateList/TemplateList';

export const TemplateListPage = () => {
  return (
    <div className={styles.mainContainer} data-test-id="templates-page">
      <div className={styles.body}>
        <TemplateList />
      </div>
    </div>
  );
};
